import { DateTime } from 'luxon';

import DA from '../store/ReduxAccess';

// export const defaultBirthdayKludge = DateTime.fromObject({ year: 1901, month: 1, day: 2, zone: 'local' });
export const defaultBirthdayKludge = DateTime.fromObject({ year: 1901, month: 1, day: 2 });

export const showAlert = (renderer, text) => {
  renderer.setState({ shouldShowAlertModal: true, alertModalText: text });
};

export const reportTime = (label, startTime, endTime) => {
  if (!endTime) {
    endTime = DateTime.local();
  }
  const startMillis = (startTime.minute * 60 + startTime.second) * 1000 + startTime.millisecond;
  const endMillis = (endTime.minute * 60 + endTime.second) * 1000 + endTime.millisecond;
  const delta = endTime.diff(startTime); // a Luxon Duration object, in milliseconds
  const durationMills = delta.as('milliseconds');
  console.log(`${label}: s:${startMillis / 1000} e:${endMillis / 1000} d:${durationMills / 1000}`);
};

export const generateRandomToken = (length) => {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let acc = '';
  for (let i = 0; i < length; i++) {
    const index = Math.floor(Math.random() * chars.length);
    const ch = chars.charAt(index);
    acc += ch;
  }
  return acc;
};

export const createStdRequest = (uri, rqMethod, apiStruct) => {
  const method = rqMethod ? rqMethod : 'GET';
  if (apiStruct) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const body = JSON.stringify(apiStruct);
    return new Request(uri, { method, headers, body });
  } else {
    return new Request(uri, { method });
  }
};

export const createTwilioRequest = (firmId, apiStruct) => {
  const uri = `/api/firm/${firmId}/sendSms`;
  return createStdRequest(uri, 'post', apiStruct);
};

export const apiFetch = (component, request, actionOnGoodResponse, rqUriCallDescrip) => {
  const uriCallDescrip = rqUriCallDescrip ? rqUriCallDescrip : computeUriCallDescrip(request);
  let gotBadResponseCode = true;
  fetch(request)
    .then((responseObj) => {
      const responseStatus = responseObj.status;
      // accept any success response
      if (responseStatus >= 200 && responseStatus < 300) {
        gotBadResponseCode = false;
        if (responseStatus == 204) {
          return '';
        } else {
          return responseObj.json();
        }
      } else {
        console.log(`Error. StatusCode: ${responseStatus}`);
        if (component) {
          component.props.setApiResponseInfo({ code: responseStatus, callDescrip: uriCallDescrip });
          if (responseStatus === 401) {
            component.setState({ redirect: '/unauthenticated' });
          } else if (responseStatus === 403) {
            component.setState({ redirect: '/unauthorized' });
          } else {
            component.setState({ redirect: '/unknownApiFailure' });
          }
        }
      }
    })
    .then((json) => {
      if (!gotBadResponseCode) {
        actionOnGoodResponse(json);
      }
    })
    .catch((err) => {
      console.log(uriCallDescrip + ' call encountered error: ', err);
    });
};

const computeUriCallDescrip = (request) => {
  const meth = request.method;
  const dblSlashLoc = request.url.indexOf('//');
  const afterDblSlash = request.url.slice(dblSlashLoc + 2);
  const nextSlashLoc = afterDblSlash.indexOf('/');
  const uri = afterDblSlash.slice(nextSlashLoc);
  return '[' + meth.toUpperCase() + '] ' + uri;
};

export const isNonLocalNonLoggedInVisitor = () => {
  return !DA.haveLoggedInUser() && window.location.hostname !== 'localhost';
};

export const isFirmReferrerType = (referrerType) => {
  return (
    referrerType &&
    referrerType !== 'Private Practitioner' &&
    referrerType !== 'Relative' &&
    referrerType !== 'Acquaintance' &&
    referrerType !== 'Self'
  );
};

// TODO for now, this is just 'Educational Consultant', but it could be
// expaned to a serious concept
export const isProprietorshipType = (referrerType) => {
  return referrerType === 'Educational Consultant';
};

export const isPractitionerType = (referrerType) => {
  return referrerType === 'Private Practitioner';
};

export const sortedDropdownItemLabels = (dropdownName) => {
  const allDropdowns = DA.getAllDropdowns();
  const dropdownSpec = allDropdowns.find((dd) => dd.name === dropdownName);
  if (!dropdownSpec) {
    return [];
  }
  const sortedItems = dropdownSpec.items.slice(0).sort((i1, i2) => i1.position - i2.position);
  return sortedItems.map((item) => item.text);
};

export const getSpecifiedFilterMenuItems = (pageFiltersState, property, specifiedOptionsAndValues) => {
  const cachedNameValuePairs = pageFiltersState ? pageFiltersState[property] || [] : [];
  const cachedNames = cachedNameValuePairs.map((pair) => pair.name);
  const items = specifiedOptionsAndValues.map((optionAndValue) => {
    const option = optionAndValue.name;
    const matchingPair = cachedNameValuePairs.find((pair) => pair.name === option);
    const haveCachedValue = cachedNames.indexOf(option) >= 0;
    const checked = haveCachedValue ? matchingPair.value : optionAndValue.value;
    return {
      name: option,
      checked,
    };
  });

  const allSelected = allMenuItemsAreChecked(items);
  const selectionButtonLabel = allSelected ? 'Unselect All' : 'Select All';

  return [{ name: selectionButtonLabel }, ...items];
};

export const getPropertyFilterMenuItems = (pageFiltersState, property, dropdownName) => {
  const cachedNameValuePairs = pageFiltersState ? pageFiltersState[property] || [] : [];
  const cachedNames = cachedNameValuePairs.map((pair) => pair.name);
  const options = sortedDropdownItemLabels(dropdownName);
  const items = options.map((option) => {
    const matchingPair = cachedNameValuePairs.find((pair) => pair.name === option);
    const haveCachedValue = cachedNames.indexOf(option) >= 0;
    const checked = haveCachedValue ? matchingPair.value : option === 'Archived' ? false : true;
    return {
      name: option,
      checked,
    };
  });

  const allSelected = allMenuItemsAreChecked(items);
  const selectionButtonLabel = allSelected ? 'Unselect All' : 'Select All';

  return [{ name: selectionButtonLabel }, ...items];
};

export const getDefaultPropertyFilterMenuItems = (dropdownName) => {
  const options = sortedDropdownItemLabels(dropdownName);
  const items = options.map((option) => {
    const checked = option === 'Archived' ? false : true;
    return {
      name: option,
      checked,
    };
  });

  const allSelected = allMenuItemsAreChecked(items);
  const selectionButtonLabel = allSelected ? 'Unselect All' : 'Select All';

  return [{ name: selectionButtonLabel }, ...items];
};

export const getUserFilterMenuItems = (pageFiltersState, property) => {
  const cachedIdNameValueTriples = pageFiltersState ? pageFiltersState[property] || [] : [];
  const cachedIds = cachedIdNameValueTriples.map((triple) => triple.id);

  const users = DA.getAllFirmUsers();
  const augmentedUsers = [{ personId: 0, name: 'Unassigned' }, ...users];
  const userPersonIds = augmentedUsers.map((user) => user.personId);
  const items = userPersonIds.map((personId) => {
    const personTriple = cachedIdNameValueTriples.find((triple) => triple.id === personId);
    const haveCachedValue = cachedIds.indexOf(personId) >= 0;
    const name = haveCachedValue
      ? personTriple.name
      : personId === 0
      ? 'Unassigned'
      : DA.getPersonById(personId).preferredFullName;
    const checked = haveCachedValue ? cachedIdNameValueTriples.find((triple) => triple.id === personId).value : true;
    return {
      id: personId,
      name,
      checked,
    };
  });

  const allSelected = allMenuItemsAreChecked(items);
  const selectionButtonLabel = allSelected ? 'Unselect All' : 'Select All';

  return [{ name: selectionButtonLabel }, ...items];
};

export const getDefaultUserFilterMenuItems = () => {
  const users = DA.getAllFirmUsers();
  const augmentedUsers = [{ personId: 0, name: 'Unassigned' }, ...users];
  const userPersonIds = augmentedUsers.map((user) => user.personId);
  const items = userPersonIds.map((personId) => {
    const name = personId === 0 ? 'Unassigned' : DA.getPersonById(personId).preferredFullName;

    return {
      id: personId,
      name,
      checked: true,
    };
  });

  const allSelected = allMenuItemsAreChecked(items);
  const selectionButtonLabel = allSelected ? 'Unselect All' : 'Select All';

  return [{ name: selectionButtonLabel }, ...items];
};

export const allMenuItemsAreChecked = (items, ignoreArchived = true) => {
  let foundUnchecked = false;
  items.forEach((item) => {
    if (!item.checked && (item.name !== 'Archived' || !ignoreArchived)) {
      foundUnchecked = true;
    }
  });
  return !foundUnchecked;
};

export const timeZoneOptions = ['Eastern', 'Central', 'Mountain', 'Pacific', 'Indiana', 'Arizona', 'Alaska', 'Hawaii'];
export const timeZoneValues = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Indiana/Indianapolis',
  'America/Phoenix',
  'America/Anchorage',
  'Pacific/Honolulu',
];

export const roundToDeadline = (date) => date.set({ hour: 17, minute: 0, second: 0, millisecond: 0 });

export const dateStringForDateTime = (dateTime) => {
  if (dateTime) {
    return dateTime.toLocaleString(DateTime.DATE_MED);
  } else {
    return '';
  }
};

export const dateStringForDateTimeIfLaterThan = (dateTime, limitDate) => {
  if (dateTime && dateTime.valueOf() >= limitDate.valueOf()) {
    return dateTime.toLocaleString(DateTime.DATE_MED);
  } else {
    return '';
  }
};

export const timeStringForDateTime = (dateTime) => {
  if (dateTime) {
    return dateTime.toLocaleString(DateTime.TIME_SIMPLE);
  } else {
    return '';
  }
};

const singleDigitRegex = /^[0-9]$/;
const openParenStr = '(';
const bareAreaCodeRegex = /^[(][0-9]{3}$/;
const closedAreaCodeRegex = /^[(][0-9]{3}[)]$/;
const withExchangeRegex = /^[(][0-9]{3}[)] [0-9]{3}$/;

export const calculatePhoneNumberChange = (oldValue, newValue) => {
  if (!newValue) {
    return { shouldUpdate: true, newValue: '' };
  }
  if (openParenStr === newValue) {
    return { shouldUpdate: true, newValue: openParenStr };
  }
  if (singleDigitRegex.test(newValue)) {
    const augmentedValue = '(' + newValue;
    return { shouldUpdate: true, newValue: augmentedValue };
  }
  if (bareAreaCodeRegex.test(newValue)) {
    const augmentedValue = newValue + ') ';
    return { shouldUpdate: true, newValue: augmentedValue };
  }
  if (closedAreaCodeRegex.test(newValue)) {
    if (oldValue.length > newValue.length) {
      const reducedValue = newValue.substring(0, 3);
      return { shouldUpdate: true, newValue: reducedValue };
    } else {
      const augmentedValue = newValue + '-';
      return { shouldUpdate: true, newValue: augmentedValue };
    }
  }
  if (withExchangeRegex.test(newValue)) {
    if (oldValue.length > newValue.length) {
      const reducedValue = newValue.substring(0, 8);
      return { shouldUpdate: true, newValue: reducedValue };
    } else {
      const augmentedValue = newValue + '-';
      return { shouldUpdate: true, newValue: augmentedValue };
    }
  }
  if (isAcceptiblePartialPhoneNumber(newValue)) {
    return { shouldUpdate: true, newValue: newValue };
  } else if (isSupportedFullPhoneNumber(newValue)) {
    const convertedToUserStd = convertToUserStdPhoneNumber(newValue);
    return { shouldUpdate: true, newValue: convertedToUserStd };
  } else {
    return { shouldUpdate: false };
  }
};

const partialAreaCodeRegex = /^[(][0-9]{1,2}$/;
const partialExchangeRegex = /^[(][0-9]{3}[)] [0-9]{0,2}$/;
const pastAreaCodeRegex = /^[(][0-9]{3}[)] [0-9]{3}-[0-9]{0,4}$/;

const isAcceptiblePartialPhoneNumber = (number) => {
  if (partialAreaCodeRegex.test(number)) return true;
  if (partialExchangeRegex.test(number)) return true;
  if (pastAreaCodeRegex.test(number)) return true;
  return false;
};

const isSupportedFullPhoneNumber = (string) => {
  return validatePhoneNumber(string).valid;
};

const digits = '0123456789';

export const isAllDigits = (str) => {
  for (let i = 0; i < str.length; i++) {
    if (digits.indexOf(str.charAt(i)) < 0) {
      return false;
    }
  }
  return true;
};

export const validatePhoneNumberAndRoles = (number, roles, label) => {
  if (number) {
    const validation = validatePhoneNumber(number, label);
    if (!validation.valid) {
      return validation;
    } else {
      return validatePhoneAndRolesConsistency(number, roles, label);
    }
  } else {
    return validatePhoneAndRolesConsistency(number, roles, label);
  }
};

const validatePhoneAndRolesConsistency = (number, roles, label) => {
  if (number) {
    if (roles) {
      return { valid: true };
    } else {
      return {
        valid: false,
        errorMessage: 'For ' + label + ', since you have supplied a number, you must also check a role',
      };
    }
  } else {
    if (roles) {
      return {
        valid: false,
        errorMessage: 'For ' + label + ', since you have  checked a role, you must also supply a number',
      };
    } else {
      return { valid: true };
    }
  }
};

export const validatePhoneNumber = (num, phoneDescripString) => {
  const stdMsg = "We only accept phone number in the format: '(AAA) EEE-NNNN'";
  const msg = phoneDescripString ? phoneDescripString + " doesn't look valid. " + stdMsg : stdMsg;
  if (num.length === 12) {
    if (num.startsWith('+1')) {
      if (isAllDigits(num.slice(2))) {
        return { valid: true };
      } else {
        return { valid: false, errorMessage: msg };
      }
    } else {
      if (num.charAt(3) !== '-') {
        return { valid: false, errorMessage: msg };
      }
      if (num.charAt(7) !== '-') {
        return { valid: false, errorMessage: msg };
      }
      const areaCode = num.slice(0, 3);
      if (!isAllDigits(areaCode)) {
        return { valid: false, errorMessage: msg };
      }
      const exchange = num.slice(4, 7);
      if (!isAllDigits(exchange)) {
        return { valid: false, errorMessage: msg };
      }
      const lastPart = num.slice(8);
      if (!isAllDigits(lastPart)) {
        return { valid: false, errorMessage: msg };
      }
      return { valid: true };
    }
  } else if (num.length === 10) {
    if (isAllDigits(num)) {
      return { valid: true };
    } else {
      return { valid: false, errorMessage: msg };
    }
  } else if (num.length === 14) {
    if (num.charAt(0) !== '(') {
      return { valid: false, errorMessage: msg };
    }
    if (num.charAt(4) !== ')') {
      return { valid: false, errorMessage: msg };
    }
    if (num.charAt(5) !== ' ') {
      return { valid: false, errorMessage: msg };
    }
    if (num.charAt(9) !== '-') {
      return { valid: false, errorMessage: msg };
    }
    const areaCode = num.slice(1, 4);
    if (!isAllDigits(areaCode)) {
      return { valid: false, errorMessage: msg };
    }
    const exchange = num.slice(6, 9);
    if (!isAllDigits(exchange)) {
      return { valid: false, errorMessage: msg };
    }
    const lastPart = num.slice(10);
    if (!isAllDigits(lastPart)) {
      return { valid: false, errorMessage: msg };
    }
    return { valid: true };
  } else {
    return { valid: false, errorMessage: msg };
  }
};

export const convertToUserStdPhoneNumber = (num) => {
  // num is in one of the forms: '+1AAAEEENNNN', 'AAAEEENNNN', 'AAA-EEE-NNNN', or '(AAA) EEE-NNNN'
  if (num.startsWith('+')) {
    // +1AAAEEENNNN
    const areaCode = num.substring(2, 5);
    const exchange = num.substring(5, 8);
    const lastPart = num.slice(8);
    return openParenStr + areaCode + ') ' + exchange + '-' + lastPart;
  } else if (num.length === 12) {
    // AAA-EEE-NNNN
    const areaCode = num.slice(0, 3);
    const exchange = num.slice(4, 7);
    const lastPart = num.slice(8);
    return openParenStr + areaCode + ') ' + exchange + '-' + lastPart;
  } else if (num.length === 10) {
    // AAAEEENNNN
    const areaCode = num.slice(0, 3);
    const exchange = num.slice(3, 6);
    const lastPart = num.slice(6);
    return openParenStr + areaCode + ') ' + exchange + '-' + lastPart;
  } else {
    // (AAA) EEE-NNNN
    return num;
  }
};

export const constructPhoneRolesString = (rolesObj, possibleRoles) => {
  let phoneRoles = '';
  possibleRoles.forEach((roleName) => {
    if (rolesObj[roleName]) {
      if (phoneRoles.length > 0) {
        phoneRoles += ',';
      }
      phoneRoles += roleName;
    }
  });
  return phoneRoles;
};

export const constructPhoneRolesArray = (rolesObj, possibleRoles) => {
  let phoneRoles = [];
  possibleRoles.forEach((roleName) => {
    if (rolesObj[roleName]) {
      phoneRoles = phoneRoles.concat(roleName);
    }
  });
  return phoneRoles;
};

export const validateEmail = (email, errorMessage) => {
  // emailPattern = /[a-zA-Z0-9+_]+@[a-zA-Z0-9]+.[a-zA-Z][a-zA-Z]+/;

  if (!email || email.length < 6) {
    return { valid: false, errorMessage };
  }
  const atLoc = email.indexOf('@');
  const lastDotLoc = email.lastIndexOf('.');
  const valid = atLoc > 0 && lastDotLoc >= atLoc + 2 && lastDotLoc <= email.length - 3;
  return { valid, errorMessage: valid ? '' : errorMessage };
};

export const validateAddress = (
  line1,
  line2,
  city,
  state,
  zip,
  requireAddress,
  forbidPartialAddress,
  allowZipFreeAddress
) => {
  if (requireAddress) {
    if (forbidPartialAddress) {
      // We require a complete address
      // First test whether there'a any address information at all
      if (!line1 && !line2 && !city && !state && !zip) {
        return { valid: false, errorMessage: 'You must supply an address' };
      }
      // Next test whether some of it is missing
      if (!line1 || !city || !state) {
        return { valid: false, errorMessage: 'You must supply a complete address' };
      }
      // OK we know that all but zip code is present.
      if (allowZipFreeAddress) {
        return validatePossiblyEmptyZip(zip);
      } else {
        return validateZip(zip);
      }
    } else {
      // we require an address, but don't forbid a parital one
      if (!line1 && !line2 && !city && !state && !zip) {
        return { valid: false, errorMessage: 'You must supply some address information' };
      } else {
        // if we have anything besides the zip code, allow the zip to be empty. But if present, validate it
        if (line1 || line2 || city || state) {
          return validatePossiblyEmptyZip(zip);
        } else {
          return validateZip(zip);
        }
      }
    }
  } else {
    if (forbidPartialAddress) {
      // We don't require an address, but if one is provided, it must be complete.
      if (line1 || line2 || city || state || zip) {
        // Now we know *something* has been provided
        if (!line1 || !city || !state) {
          return { valid: false, errorMessage: 'If you supply an address, it must be a complete one' };
        }
        // So we know they've supplied everything except possibly a zip code.
        if (allowZipFreeAddress) {
          return validatePossiblyEmptyZip(zip);
        } else {
          return validateZip(zip);
        }
      } else {
        // No address info has been provided, so it's not partial, ergo valid.
        return { valid: true };
      }
    } else {
      // No address is required, and a provided one may be partial, so just validate zip code, if any
      return validatePossiblyEmptyZip(zip);
    }
  }
};

const validatePossiblyEmptyZip = (zip) => {
  if (!zip || zip.length === 0) {
    return { valid: true };
  } else {
    return validateZip(zip);
  }
};

const validateZip = (zip) => {
  if (zip) {
    if (zip.length === 5) {
      if (!isAllDigits(zip)) {
        return { valid: false, errorMessage: 'A 5-digit Zip code must contain only digits' };
      }
      return { valid: true };
    } else if (zip.length === 10) {
      if (zip.charAt(5) === '-') {
        return { valid: false, errorMessage: "The sixth character of a 10-digit Zip code must be '-'" };
      }
      const preDash = zip.slice(0, 5);
      if (!isAllDigits(preDash)) {
        return { valid: false, errorMessage: 'The first five characters of a 10-digit Zip code must all be digits' };
      }
      const postDash = zip.slice(6);
      if (isAllDigits(postDash)) {
        return { valid: false, errorMessage: 'The last four characters of a 10-digit Zip code must all be digits' };
      }
      return { valid: true };
    } else {
      return { valid: false, errorMessage: 'A valid Zip code must have either 5 or 10 characters' };
    }
  } else {
    return { valid: true };
  }
};

const containsDigit = (str) => {
  for (let i = 0; i < str.length; i++) {
    if (digits.indexOf(str.charAt(i)) >= 0) {
      return true;
    }
  }
  return false;
};

const containsUppercase = (str) => {
  for (let i = 0; i < str.length; i++) {
    const char = str.charAt(i);
    if (char >= 'A' && char <= 'Z') {
      return true;
    }
  }
  return false;
};

const containsAtLeastNUniqueChars = (str, n) => {
  const chars = new Set();
  for (let i = 0; i < str.length; i++) {
    chars.add(str.charAt(i));
  }
  return chars.size >= n;
};

export const validateAcceptablePassword = (pwd) => {
  if (pwd.length < 8) {
    return { valid: false, errorMessage: 'Your Password must be at least eight characters long' };
  }
  if (!containsDigit(pwd)) {
    return { valid: false, errorMessage: 'Your Password must contain at least one digit' };
  }
  if (!containsUppercase(pwd)) {
    return { valid: false, errorMessage: 'Your Password must contain at least one uppercase letter' };
  }
  if (!containsAtLeastNUniqueChars(pwd, 4)) {
    return { valid: false, errorMessage: 'Your Password must contain at least four different characters' };
  }
  return { valid: true };
};

export const saveWebsiteLinkToDb = (page, viewingFirmId, visibleFirmId, updateFirmFunc, newText, showSnackbar) => {
  // build API struct
  const visibleFirm = DA.getFirmById(visibleFirmId);
  const apiStruct = buildApiStructForUpdatingWebsiteLink(visibleFirm, newText);
  const uri = `/api/firm/${viewingFirmId}/visibleFirm/${visibleFirmId}`;
  const request = createStdRequest(uri, 'put', apiStruct);
  const actionOnGoodResponse = () => {
    const copiedRep = { ...visibleFirm, webLinks: apiStruct.webLinks };
    updateFirmFunc(copiedRep);
    showSnackbar();
  };
  // call API
  apiFetch(page, request, actionOnGoodResponse);
};

export const deleteWebsiteLinkFromDb = (page, viewingFirmId, visibleFirmId, updateFirmFunc, showSnackbar) => {
  // build API struct
  const visibleFirm = DA.getFirmById(visibleFirmId);
  const apiStruct = buildApiStructForUpdatingWebsiteLink(visibleFirm, null);
  const uri = `/api/firm/${viewingFirmId}/visibleFirm/${visibleFirmId}`;
  const request = createStdRequest(uri, 'put', apiStruct);
  const actionOnGoodResponse = (json) => {
    const filteredLinks = apiStruct.webLinks.filter((link) => link.linkType !== 'Website');
    const copiedRep = { ...visibleFirm, webLinks: filteredLinks };
    updateFirmFunc(copiedRep);
    showSnackbar();
  };
  // call API
  apiFetch(page, request, actionOnGoodResponse);
};

function buildApiStructForUpdatingWebsiteLink(visibleFirm, url) {
  const { name, firmType } = visibleFirm;
  return {
    firmId: visibleFirm.firmId,
    name,
    firmType,
    webLinks: [{ linkType: 'Website', url }],
  };
}

export const logWithTime = (message) => {
  const enabled = false;
  if (enabled) {
    const nSecsToPreserve = 1000;
    const nMillisToPreserve = nSecsToPreserve * 1000;
    const currentMillis = DateTime.local().toMillis();
    const preservedMillis = currentMillis % nMillisToPreserve;
    const secsAndMillis = preservedMillis / 1000;
    console.log(`${secsAndMillis}: ${message}`);
  }
};

export const filterIsInDefaultState = (menuItems, defaultMenuItems) => {
  let foundMismatch = false;
  menuItems.forEach((item) => {
    if (item.hasOwnProperty('checked')) {
      const matchingDefaultItem = defaultMenuItems.find((defaultItem) => defaultItem.name === item.name);
      if (matchingDefaultItem && matchingDefaultItem.checked !== item.checked) {
        foundMismatch = true;
      }
    }
  });
  return !foundMismatch;
};
